import React from "react";
export default function ActiveIcon(props) {
    return (
        <div>
            <div className={props.attivo ? "tally-active-icon": "tally-deactive-icon"} />
            {props.testo}
        </div>)
}